import { redirectIfAccessError } from "@lib/access/authRedirect";
import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/me/organisations/picture/{type}").POST();

export type UploadOrganisationPictureResp = typeof endpoint.types.Res;

export async function uploadOrganisationPicture(
    formData: FormData,
    pictureType: string,
): Promise<UploadOrganisationPictureResp | null> {
    try {
        const call = createCall(endpoint, (request) => {
            const scopedRequest = withAccountOrNetworkAuthHeaders(request);
            return fetch(new Request(scopedRequest, { body: formData }));
        });
        return await call({ params: { type: pictureType } });
    } catch (error) {
        redirectIfAccessError(error);
        return null;
    }
}
